module.exports = __webpack_public_path__ + "img/fraud-bg.6f6eba5d.png";